import React from 'react';
import ReactDOM from 'react-dom/client';
// CSS ORDER IS LOAD-BEARING: vendor reset -> globals -> per-page CSS.
// Bootstrap's Reboot styles body/h1/h2/h3/code, and index.css (which absorbed
// App.css on 2026-09-21) overrides them. It only wins if bootstrap is imported
// FIRST. Moving either line below the other hands every heading in the app back
// to bootstrap. Bootstrap used to be imported from App.js, which is why this
// worked before the merge.
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
// After './index.css' on purpose: this component ships its own stylesheet and
// the order rule above applies to it too — globals first, component CSS after.
import DocumentScrollbar from './components/DocumentScrollbar/DocumentScrollbar';
window.isMobile = function(){
  return (window.matchMedia("(any-hover:none)").matches)
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {/* Fixed gradient background layer. */}
    <div className="background-div" />
    {/* Overlay bar for the page. Mounted here rather than inside <App> so
        it is a sibling of the background and the content, not a child of
        either — nothing it draws should inherit a page's stacking or
        transforms. */}
    <DocumentScrollbar />
    <div className="content">
      <App />
    </div>
  </>
);
